import { trpc } from '@/shared/api/trpc';

export const useCreateTaskFromSet = () => {
  const utils = trpc.useUtils();
  return trpc.tasks.createFromSet.useMutation({
    onSettled: () => {
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
      utils.taskCollections.availableForItinerary.invalidate();
    },
  });
};
